<template>
  <GeneralTheme :theme="configuration">
    <div :class="{ 'container mx-auto': !fullWidthContent }">
      <div
        :class="{
          'grid grid-cols-12 items-center gap-3': true,
        }"
      >
        <div
          v-for="component in contentGrid?.content?.sectionBuilder"
          :key="component._key"
          :class="gridColumClass"
        >
          <BlockTheme :theme="contentBlocks">
            <component
              :is="getComponent(component._type)"
              :value="component"
            />
          </BlockTheme>
        </div>
      </div>
    </div>
  </GeneralTheme>
</template>

<script setup lang="ts">
import { getComponent } from '~/components/Mapper';
import type { SectionBuilderContentGrid } from '~/sanity/types';

const props = defineProps<SectionBuilderContentGrid>();
if (!props.contentGrid) {
  throw new Error('ContentGrid component is missing content');
}
const { columnsPerRow } = toRefs(props.contentGrid);
const gridColumClass = computed(() => {
  return {
    [columnsClass[columnsPerRow.value]]: true,
  };
});
const columnsClass = {
  '2': 'w-full col-span-12 md:col-span-6 h-full',
  '3': 'w-full col-span-12 md:col-span-4 h-full',
  '4': 'w-full col-span-12 md:col-span-3 h-full',
};
</script>

<style scoped></style>
